<template>
  <div class="terms container my-5">
    <h2 class="text-center">會員條款與隱私權政策</h2>
    <br />

    <p class="muted">
      遠京企業股份有限公司（以下稱「本公司」）依據法令及營運需求，訂立以下會員條款與隱私政策，以保障會員權益與個人資料安全。
    </p>
    <br />

    <h3>一、平台定位</h3>
    <ul>
      <li>本網站僅限合法醫療從業人員（如醫師、護理師、診所或醫院）註冊使用，一般消費者無法註冊。未來若有變更，將另行公告。</li>
    </ul>
    <br />

    <h3>二、同意與使用規範</h3>
    <ul>
      <li>註冊或使用即視為同意本條款。</li>
      <li>本公司得隨時修訂條款，並公告於網站。</li>
      <li>請填寫真實、完整的資料，以利會員資格審核。</li>
      <li>本公司保留審核與調整服務的權利。</li>
    </ul>
    <br />

    <h3>三、會員註冊與帳號管理</h3>
    <ul>
      <li>每位會員限一帳號，不得冒用他人或重複註冊。</li>
      <li>資料變更應即時更新，否則影響使用權益由會員自負。</li>
      <li>帳號僅限本人使用，請妥善保管，如有異常請即通知本公司。</li>
    </ul>
    <br />

    <h3>四、個人資料使用</h3>
    <h4>1、蒐集目的</h4>
    <ul>
      <li>法令依據：依據《個人資料保護法》規範</li>
      <li>特定目的編號：
        <ul>
          <li>040 行銷</li>
          <li>090 消費者、客戶管理與服務</li>
        </ul>
      </li>
      <li>目的內容：提供優惠活動資訊、寄送產品消息、分享專業新知，或由專人聯繫進行後續諮詢服務。</li>
    </ul>

    <h4>2、蒐集資料類別</h4>
    <ul>
      <li>C001：個人識別資訊（如姓名、行動電話、電子郵件信箱）</li>
    </ul>

    <h4>3、利用期間、地區、對象與方式</h4>
    <ul>
      <li>利用期間：自您提供資料起，於本公司營運期間內保存與使用。</li>
      <li>利用地區：限於中華民國（臺灣）境內使用。</li>
      <li>利用對象及方式：資料僅供本公司內部建檔、推廣產品資訊及提供相關服務使用。</li>
    </ul>

    <h4>4、您的權利</h4>
    <p>依《個人資料保護法》第三條規定，您享有以下權利：</p>
    <ul>
      <li>查詢或請求閱覽您的個人資料</li>
      <li>請求製給資料複本</li>
      <li>請求補充或更正資料</li>
      <li>請求停止蒐集、處理或利用資料</li>
      <li>請求刪除資料</li>
    </ul>
    <p>若您欲行使上述權利，請於營業時間透過書面或電話聯繫本公司，將有專人協助辦理。</p>

    <h4>5、其他提醒事項</h4>
    <p>您可選擇不提供個人資料，惟本公司將無法提供完整之產品資訊與相關服務，敬請見諒。</p>
    <br />

    <h3>五、使用規範</h3>
    <ul>
      <li>會員不得進行違法、侵權或干擾平台正常運作之行為，如散布不實訊息、傳播病毒、廣告推銷、冒用他人等。</li>
    </ul>
    <br />

    <h3>六、服務中斷情況</h3>
    <ul>
      <li>網站可能因維護、設備故障、電信異常或不可抗力而暫時中斷，敬請見諒。</li>
    </ul>
    <br />

    <h3>七、會員資格終止</h3>
    <p>如有下列情形，本公司有權停止或取消會員資格：</p>
    <ul>
      <li>提供不實資料或惡意註冊</li>
      <li>使用他人帳號</li>
      <li>干擾網站運作</li>
      <li>違反法令或侵犯他人權益</li>
    </ul>
    <br />

    <div class="foot-actions">
      <router-link class="btn btn-dark" :to="{ name: 'AppProfile' }">返回會員資料</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsPrivacy',
}
</script>

<style scoped lang="scss">
.terms {
  margin-top: calc(var(--header-height, 58px) + 12px);
  text-align: start;

  h1, h2, h3, h4 {
    color: black !important;
  }

  p, li {
    line-height: 1.8;
    color: #222;
  }

  .muted {
    color: #666;
  }

  ol, ul {
    padding-left: 1.2em;
  }

  .foot-actions {
    margin-top: 8px;
  }
}
</style>
